<template>
  <div class="t-container">
    <v-data-table
      :search="search"
      :headers="tableHeaders"
      :items="items"
      :item-class="rowClass"
      :loading="loading"
      @pagination="paginationUpdated($event)"
    >
      <template v-slot:loading>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>

      <template v-slot:[`item.cardName`]="{ item }">
        <b-link @click="displayCardTypeDetails(item)">
          {{ item.cardName }}</b-link
        >
      </template>

      <template v-slot:[`item.deleteCardType`]="{ item }">
        <b-link @click="deleteCardType(item)">
          <v-icon color="red darken-1">delete_forever</v-icon>
        </b-link>
      </template>
    </v-data-table>
  </div>
</template>
<style></style>
<script>
export default {
  props: {
    items: Array,
    search: String,
    loading: Boolean
  },
  data() {
    return {};
  },
  computed: {
    tableHeaders() {
      const tableHeaders = [];
      tableHeaders.push({
        text: "Card Name",
        value: "cardName",
        align: "center"
      });
      tableHeaders.push({
        text: "Short Card Name",
        value: "shortCardName",
        align: "center"
      });
      tableHeaders.push({
        text: "Starting Digits",
        value: "startingDigits",
        align: "center"
      });
      tableHeaders.push({
        text: "Card Length",
        value: "constraints.cardLength",
        align: "center"
      });
      tableHeaders.push({
        text: "Delete",
        value: "deleteCardType",
        align: "center"
      });

      return tableHeaders;
    }
  },
  methods: {
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    displayCardTypeDetails(cardTypeData) {
      //Converts to a normal object
      //Without out it, changing cardLength in the modal will immediately change the cardLength displayed in the table
      let normalObject = JSON.parse(JSON.stringify(cardTypeData));
      this.$emit("eViewCardTypeCRUDModal", normalObject);
    },
    paginationUpdated(event) {
      this.$emit("eTablePagination", event);
    },
    deleteCardType(cardTypeData) {
      this.$emit("eDeleteCardType", cardTypeData.shortCardName);
    }
  }
};
</script>
